import React, { Fragment } from 'react'

export default function LogsListing(props) {
  const { logs, TableBody, TableHead, wrapperClasses, tableClasses, emptyRecordMsg, showAddNew, AddNewComp, loading, HeaderHeadComponent } = props

  return (
    <div className={`overview-table ${wrapperClasses}`}>
      <table className={`table table-hover bg-white ${tableClasses}`}>
        <thead className="text-dark border-bottom border-light border-bottom-2">
          {HeaderHeadComponent && <HeaderHeadComponent />}
          <tr>
            {TableHead.map((head) => !head.showOnly && <th scope="col" className={`${head.className}`} {...head.attribute}>
              {head.Component ?
                <head.Component /> :
                head.title
              }
            </th>)}
          </tr>
        </thead>
        <tbody>
          {TableBody ?
            <>
              {showAddNew && <AddNewComp />}
              {logs.length ?
                logs.map((log, index) => <Fragment key={log.id}><TableBody log={log} index={index} /></Fragment>) :
                !loading && <tr>
                  <td colSpan={14} className='text-center font-size-18'>{emptyRecordMsg ?? 'No Record Found'}</td>
                </tr>
              }
            </> :
            <>{props.children}</>
          }
          {loading &&
            <tr>
              <td colSpan={14} className='text-center loading text-primary font-weight-bold'>
                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span> Loading...
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  )
}
